import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Box, Typography, IconButton, Paper, InputBase } from '@mui/material';
import { Search, Upload, Add, FilterList, UploadOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { styled } from '@mui/material/styles';
import api from '../../utils/api';
import UserHeader from '../../component/reusable/UserHeader';
import { setSubcategoryRefresh } from '../../redux/subcategories/getAllSubcategorySlice';
import AllSampleReqTable from '../../component/sampleReqComp/AllSampleReqTable';
import { getAllCategoriesThunk } from '../../redux/category/getAllCategorySlice';
import { exportSampleRequest, getAllSampleRequestThunk, setsampleRequestPage } from '../../redux/sampleRequestSlice';
import SampleRequestfilter from '../../component/sampleReqComp/SampleRequestfilter';
import { exportDataExcel, fomateDate } from '../../utils/fomateDate';






function SampleReq() {
    const [limit, setLimit] = useState(25)
    const [sortBy, setSortyBy] = useState('createdAt');
    const [order, setOrder] = useState('asc')
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { samplerequest, loading, refresh, page, search, status, fromDate, exportLoading } = useSelector((state) => state.samplerequest);
    const sampleRequestData = samplerequest?.data
    const totalPages = samplerequest?.totalPages
    const totalItems = samplerequest?.totalItems
    const itemsPerPage = samplerequest?.limit



    const start = (page - 1) * limit + 1;
    const end =
        totalPages === page
            ? totalItems
            : (page - 1) * limit + limit;


    useEffect(() => {
        dispatch(getAllSampleRequestThunk(`?search=${search}&page=${page}&status=${status}&fromDate=${fromDate}&toDate=${fromDate}&sortBy=${sortBy}&order=${order}`));
    }, [page, search, status, limit, refresh, sortBy, order, fromDate]);


    const handleOpenMenu = (sort) => {
        setSortyBy(sort)
        setOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    };

    const exportSampleRequests = async () => {
        const status = await dispatch(exportSampleRequest(`?limit=${100000}`))
        if (status?.payload?.success === true) {
            console.log("status", status?.payload?.data?.data);

            const samplerequestdata = status?.payload?.data?.data
            const exportdata = samplerequestdata?.map((item) => ({
                'id': item?._id || '-',
                'customer Name': item?.user?.fullName || '-',
                'Customer Email': item?.user?.email || '-',
                'Product Name': item?.product?.productOverview?.productNumber[0] || '-',
                'Manufacturer': item?.product?.productOverview?.manufacturer[0]?.name || '-',
                'Quantity': item?.quantity || '-',
                'projectName': item?.projectName || '-',
                'application': item?.application || '-',
                'createdAt': fomateDate(item?.createdAt),
            }))
            exportDataExcel(exportdata, "sample-request")
        }
    }

    return (
        <>
            <UserHeader
                index="Sample Requests"
                root="Dashboard"
                onClickadd={() => navigate('/users/addVendor')}
                hideadd="hide"
                exportData={exportSampleRequests}
                exportLoading={exportLoading}
            />

            <SampleRequestfilter />
            {loading ? <div>Please Wait...</div> : 
            <>
                {
                    sampleRequestData?.length > 0 ?
                        <Typography>
                            <AllSampleReqTable
                                sampleRequestData={sampleRequestData}
                                page={page}
                                setPage={setsampleRequestPage}
                                itemsPerPage={itemsPerPage}
                                totalItems={totalItems}
                                totalPages={totalPages}
                                start={start}
                                end={end}
                                handleOpenMenu={handleOpenMenu}

                            />
                        </Typography>
                        :
                        <div style={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center' }}>No Request found</div>

                }
            </>
}
        </>
    );
}

export default SampleReq;
